/**
 * apps/battle/client/src/terminal/components/TerminalFrame.tsx
 * Shared chrome for every terminal screen: header line + body + bottom keybar.
 *
 * Pure presentation; FSM transitions happen in the screen components.
 */
import type { ReactNode } from 'react';

interface TerminalFrameProps {
  /** Header bar, e.g. "ECONQUEST  ─  CLUSTER A  ─  XP: 142  ─  LVL 2" */
  title: ReactNode;
  /** Right-side meta, optional (e.g. attempt dots) */
  meta?: ReactNode;
  /** Main body content. */
  children: ReactNode;
  /** Bottom key bar (use <KeyBar/>). */
  keybar: ReactNode;
}

export function TerminalFrame({ title, meta, children, keybar }: TerminalFrameProps) {
  return (
    <div className="tm-frame">
      <div className="tm-frame__header">
        <div className="tm-frame__title">{title}</div>
        {meta && <div className="tm-frame__meta">{meta}</div>}
      </div>
      <div className="tm-frame__body">{children}</div>
      <div className="tm-frame__keybar">{keybar}</div>
    </div>
  );
}
